import { render, staticRenderFns } from "./DefaultersReport.vue?vue&type=template&id=fe802fb6&scoped=true&"
import script from "./DefaultersReport.vue?vue&type=script&lang=js&"
export * from "./DefaultersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe802fb6",
  null
  
)

export default component.exports